var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountStepsExpanse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_8862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3137 12.0637C11.728 12.0637 12.0637 11.7279 12.0637 11.3137V7.07106C12.0637 6.65685 11.728 6.32106 11.3137 6.32106C10.8995 6.32106 10.5637 6.65685 10.5637 7.07106V10.5637L7.07111 10.5637C6.65689 10.5637 6.32111 10.8995 6.32111 11.3137C6.32111 11.7279 6.65689 12.0637 7.07111 12.0637L11.3137 12.0637ZM4.24268 9.23528H8.48532C8.89953 9.23528 9.23532 8.89949 9.23532 8.48528L9.23532 4.24264C9.23532 3.82842 8.89953 3.49264 8.48532 3.49264C8.07111 3.49264 7.73532 3.82842 7.73532 4.24264L7.73532 7.73528L4.24268 7.73528C3.82847 7.73528 3.49268 8.07106 3.49268 8.48528C3.49268 8.89949 3.82847 9.23528 4.24268 9.23528Z",
    fill: "url(#paint0_linear_228_8862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_8862",
    x1: 11.8441,
    y1: 11.844,
    x2: 5.83367,
    y2: 5.83363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00395D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00395D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_8862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(16.9706 8.48535) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountStepsExpanse);
export default __webpack_public_path__ + "static/media/count-steps-expanse.3f927cb76aca57dbda6379351efee084.svg";
export { ForwardRef as ReactComponent };